import { Alert, AlertModal } from '../../..'
import { observer } from 'mobx-react-lite'
import { Icons } from '../../../misc/Icons'
import { store } from '../../../stores/Store'
import PanelBody from '../../layout/PanelBody'
import PanelHeader from '../../layout/PanelHeader'
import { Button, IconButton, LinearProgress } from '@mui/material'
import ErrorBoundary from '../../../misc/ErrorBoundary'
import TemplateTable from './TemplateTable'
import TemplateForm from '../../form/questionnaire/TemplateForm'
import Ajax from '../../../Ajax'
import { formatDistance } from 'date-fns'
import { Questionnaire, Template } from '../../../models/Interfaces'
import { TemplateEditForm } from './TemplateForm'
import TemplateSettingsForm from './TemplateSettingsForm'


const openSingleTemplate = (uid) => {
    AlertModal({body: <TemplateEditForm templateUid={uid} />, width: "800px"})
}

const openFullTemplateList = () => {
    AlertModal({title: "All Templates", body: <TemplateTable onRowClick={(uid) => openSingleTemplate(uid)} />, width: "900px"})
}


const templateModuleList: Template[] = [
    {
        uid: "QT_123",
        key: "QT_123",
        version: "1.1.12",
        displayName: "Personal details",
        json: "{}",
        insertedAt: "2026-04-12",
    },
    {
        uid: "QT_123",
        key: "QT_123",
        version: "1.1.12",
        displayName: "Living arrangements",
        json: "{}",
        insertedAt: "2026-04-12",
    },
    {
        uid: "QT_123",
        key: "QT_123",
        version: "1.1.12",
        displayName: "Family and relationships",
        json: "{}",
        insertedAt: "2026-04-12",
    },
    {
        uid: "QT_123",
        key: "QT_123",
        version: "1.1.12",
        displayName: "Travel history",
        json: "{}",
        insertedAt: "2026-04-12",
    },
    {
        uid: "QT_123",
        key: "QT_123",
        version: "1.1.12",
        displayName: "Disqualifying factors",
        json: "{}",
        insertedAt: "2026-04-12",
    }
]


export default observer(function TemplateTool () {

    const sysUser = store.AppStore.checkJwtRole("sysuser")

    const { templates } = store.QuestionnaireStore

    var activeTemplates = Array.isArray(templates) && templates.length ? (
        [...templates].sort((a, b) => a.displayName.localeCompare(b.displayName)).filter(t => t.active)
    ) : []

    return (
        <ErrorBoundary>
            <div className="panel panel-dark">
                <PanelHeader>
                    <div style={{display: "flex", gap: "10px", flexFlow: "wrap", alignItems: "center"}}>
                        <h2>Questionnaire settings</h2>

                        {sysUser ? (
                            <Button
                                color="success"
                                variant="contained"
                                className="btn btn-sm"
                                onClick={() => AlertModal({body: <TemplateCreate />, width: "900px"})}>
                                Create Template
                            </Button>
                        ) : null}
                    </div>

                    <IconButton color="info" style={{margin: "0 0 auto auto"}} size="small" onClick={() => store.ToolStore.setTool(null)}><Icons.X /></IconButton>
                </PanelHeader>

                <PanelBody>
                    <div>
                        <p>Questionnaires are made using Templates. Here you can manage your Templates and their default settings.</p>

                        {sysUser ? (
                            <p className="link" onClick={() => openFullTemplateList()}>You can see the full list of active and incative Templates here.</p>
                        ) : null}
                    </div>

                    <div style={{display: "flex", gap: "40px", flexWrap: "wrap", margin: "20px 0 40px 0", overflowY: "auto", paddingRight: "15px"}}>
                        <div>
                            <h3>Active Templates</h3>

                            <p>Here is a list of all the active and available Questionnaire Templates.</p>

                            {store.AppStore.sessionInfo.isSelfAdviser ? (
                                <p><span className="link" onClick={() => openFullTemplateList()}>Click here</span> to see the full list of Templates including ones which are no longer active.</p>
                            ) : null}

                            <div style={{width: "100%", minWidth: "300px", maxWidth: "800px", display: "grid", gap: "15px"}}>
                                {activeTemplates.map((template, i) => <TemplateListItem template={template} />)}
                            </div>
                        </div>

                        {sysUser && false ? (
                            <div>
                                <div style={{display: "flex", gap: "10px"}}>
                                    <h3>Template Modules <b className="warning">UI only</b></h3>
                                </div>

                                <p>Template modules can be imported when disigning Questionnaire Templates.</p>

                                <div style={{width: "100%", minWidth: "300px", maxWidth: "800px", display: "grid", gap: "15px", paddingRight: "4px"}}>
                                    {templateModuleList.map((template, i) => <TemplateModuleListItem template={template} />)}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </PanelBody>
            </div>
        </ErrorBoundary>
    )
})

interface TemplateListItemProps {
    template: Template;
}

function TemplateListItem ({template}: TemplateListItemProps) {

    const templateQuestionnaires = store.QuestionnaireStore.questionnaires?.filter((q: Questionnaire) => q.template.key === template.key && q.template.version === template.version)
    const advisor = template.advisor ? store.NodeStore.accounts.find(a => a.advisorUid === template.advisor) : null

    return (
        <div className="tool-section" style={{maxWidth: "600px"}}>
            <div className="tool-table">
                <div className="header">
                    <small className="link" onClick={() => openSingleTemplate(template.uid)}>{template.displayName}</small>
                    <small>{template.key} {template.version}</small>
                </div>

                <div style={{display: "grid", gap: "10px", margin: "10px 0"}}>
                    <small>Last updated {formatDistance(new Date(), new Date(template.insertedAt))} ago.</small>
                    <small>Used {templateQuestionnaires?.length} times.</small>
                    {advisor ? (
                        <small>This Template is assigned to {advisor.accountName}.</small>
                    ) : (
                        <small>This is a Global Template</small>
                    )}
                </div>

                <div style={{display: "flex", gap: "10px"}}>
                    <Button
                        color="secondary"
                        variant="contained"
                        className="btn btn-sm"
                        onClick={() => AlertModal({width: "500px", body: <TemplateSettingsForm templateUid={template.uid} />})}>
                        Edit default settings
                    </Button>
                </div>
            </div>
        </div>
    )
}


function TemplateModuleListItem ({template}) {

    return (
        <div className="tool-section" style={{maxWidth: "600px"}}>
            <div className="tool-table">
                <div className="header">
                    <small className="link">{template.displayName}</small>
                    <small>{template.key} {template.version}</small>
                </div>

                <div style={{display: "grid", gap: "10px", margin: "10px 0"}}>
                    <small>Last updated {formatDistance(new Date(), new Date(template.insertedAt))} ago.</small>
                </div>
            </div>
        </div>
    )
}





function TemplateCreate () {
    return (
        <TemplateForm
            title="Create Template"
            onSubmit={async (values) => {
                await Ajax.QuestionnaireTemplate.Create(values).then(() => {
                    store.AlertStore.Close()
                    store.QuestionnaireStore.getTemplates()
                }).catch((response) => {
                    Alert({message: response.data?.detail ? response.data?.detail : "Couldn't create template"})
                })
            }} />
    )
}